<template>
  <div class="coolant-sample-graph" v-if="!isLoading">
    <CoolantSampleGraphBar
      v-if="isSingleSampleSelected"
      :legendPreset="legendPreset"
      :sampleData="selectedSample"
      @customSelection="legendPreset = null"
    />
    <CoolantSampleGraphLine
      v-else
      :legendPreset="legendPreset"
      :sampleData="sampleData"
      :sampleCount="sampleCount"
      ref="lineGraph"
      @customSelection="legendPreset = null"
    />
    <div class="toolbar">
      <div class="date-selector">
        <select class="dropdown" v-model="selectedSample" ref="selectedSample">
          <option value="">View Unit</option>
          <option v-for="(sample, index) in sampleData" :key="index" :value="sample">
            {{ sample.dateReceived | formatTime }}
          </option>
        </select>
      </div>
      <div class="preset-selector">
        <select class="dropdown" v-model="legendPreset">
          <option v-for="({ name, options }, index) in legendPresets" :value="options" :key="index">
            {{ name }}
          </option>
          <option :value="null">Custom</option>
        </select>
      </div>
      <div class="custom-legend" ref="customLegend"></div>
      <div class="date-control">
        <div class="date-arrows">
          <button @click="moveUnitSelection(false)">
            <i class="icon icon-keyboard_arrow_left"></i>
          </button>
          <button @click="moveUnitSelection(true)">
            <i class="icon icon-keyboard_arrow_right"></i>
          </button>
        </div>
        <select class="dropdown" v-model="sampleCount" :disabled="isSingleSampleSelected">
          <option :value="1">1</option>
          <option :value="5">5</option>
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import GridDataService from 'services/grid-data.service';
import Constants from '../../../constants/constants';
import CoolantSampleGraphBar from './CoolantSampleGraphBar.vue';
import CoolantSampleGraphLine from './CoolantSampleGraphLine.vue';

export default {
  name: 'CoolantSampleGraph',
  components: {
    CoolantSampleGraphBar,
    CoolantSampleGraphLine
  },
  filters: {
    formatTime(value) {
      if (!value) {
        return;
      }

      return value.split('T')[0];
    }
  },
  data() {
    return {
      legendPresets: Constants.Graph.CoolantSample.legendPresets,
      legendPreset: null,
      isLoading: true,
      sampleCount: 10,
      sampleData: [],
      selectedSample: '',
      selectedSampleId: 0
    };
  },
  computed: {
    isSingleSampleSelected() {
      return typeof this.selectedSample === 'object';
    }
  },
  watch: {
    selectedSample(sample) {
      this.selectedSampleId = sample?.coolantSampleID;
    }
  },
  mounted() {
    const queryString = new URLSearchParams(window.location.search);
    const id = parseInt(queryString.get('id'), 10);

    if (!id) {
      window.alert('The ID given does not exist or none was provided. Please try again.');

      return;
    }

    GridDataService.getGraphData({
      apiUrl: Constants.Api.Endpoint.CoolantSample.graphApi,
      params: {
        id
      }
    }).then(({ data }) => {
      this.sampleData = data;
      this.isLoading = false;
      this.selectedSampleId = id;
      this.selectedSample = '';

      if (queryString.get('viewunit') !== null) {
        const sample = data.find(({ coolantSampleID }) => coolantSampleID === id);
        if (sample) {
          this.selectedSample = sample;
        }
      }
    });
  },
  methods: {
    moveUnitSelection(moveForward) {
      const { options, selectedIndex } = this.$refs.selectedSample;
      // Subtract two for extra non-date option and for options.length being one indexed and selectedIndex zero indexed.
      // Subtract one for the View Unit option.
      if (!moveForward && selectedIndex < options.length - 2) {
        this.$refs.selectedSample.selectedIndex += 1;
      } else if (selectedIndex === options.length - 1) {
        this.$refs.lineGraph.moveUnitSelection(moveForward);
        return;
      } else if (moveForward && selectedIndex) {
        this.$refs.selectedSample.selectedIndex -= 1;
      }

      this.selectedSample = this.sampleData[this.$refs.selectedSample.selectedIndex];
    }
  }
};
</script>

<style lang="scss" scoped>
.coolant-sample-graph {
  display: grid;
  grid: 1fr / 9fr 1fr;
  // margin-top: -50px;
  padding: 20px;

  .toolbar {
    display: flex;
    flex-flow: column nowrap;
    justify-items: center;

    .date-selector,
    .preset-selector,
    .custom-legend,
    .date-control {
      border-bottom: solid 2px $gray;
      margin-bottom: 10px;
      padding-bottom: 10px;
    }

    .dropdown {
      background: $white;
      border: solid 1px rgba(0, 0, 0, 0.8);
      color: $black;
      cursor: pointer;

      &[disabled] {
        opacity: 0.25;
      }
    }

    .custom-legend {
      :deep(.group:first-child) {
        border-bottom: solid 2px $gray;
        margin-bottom: 5px;
        padding-bottom: 5px;
      }

      :deep(.item) {
        align-items: center;
        color: $black-offset;
        cursor: pointer;
        display: flex;
        user-select: none;

        &.not-visible {
          color: $gray;
        }

        .symbol {
          border-radius: 10px;
          height: 10px;
          margin-right: 5px;
          width: 10px;
        }
      }
    }

    .date-control {
      .date-arrows button {
        font-size: 30px;
        margin-bottom: 10px;
        outline: none;
      }
    }
  }
}
</style>
